interface ProductSelectorProps {
  products: Array<{ value: string; label: string }>;
  value: string;
  onChange: (val: string) => void;
  allLabel?: string;
}

export function ProductSelector({
  products,
  value,
  onChange,
  allLabel = "All Products",
}: ProductSelectorProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="rounded-md border border-input bg-background px-3 py-1.5 text-sm text-foreground"
    >
      <option value="">{allLabel}</option>
      {products.map((p) => (
        <option key={p.value} value={p.value}>
          {p.label}
        </option>
      ))}
    </select>
  );
}
